module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [(_vm.getChangeQuotes) ? _c('AddQuotes') : _vm._e(), _c('Navbar'), _c('Filters', {
    staticClass: "mobile"
  }), _c('QuotesList')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dfadb89a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/layouts/Home/Home.pug
// module id = 268
// module chunks = 2